import { render, staticRenderFns } from "./Availability.vue?vue&type=template&id=5995b99c&scoped=true&"
import script from "./Availability.vue?vue&type=script&lang=ts&"
export * from "./Availability.vue?vue&type=script&lang=ts&"
import style0 from "./Availability.vue?vue&type=style&index=0&id=5995b99c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5995b99c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsCheckmark16px: require('/var/www/packages/theme/components/icons/checkmark/Checkmark16px.vue').default,AtomsKELabel: require('/var/www/packages/theme/components/atoms/KELabel.vue').default,MoleculesAvailabilityDrawer: require('/var/www/packages/theme/components/molecules/AvailabilityDrawer.vue').default})
